import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-paper px-4 text-center">
      <h1 className="font-display text-3xl font-semibold">This page hasn't been taught yet.</h1>
      <p className="mt-2 font-body text-sm text-ink/60">Let's get you back to the dashboard.</p>
      <Link to="/dashboard" className="mt-6 rounded-xl bg-marker px-5 py-2.5 font-body text-sm text-paper">
        Back to Dashboard
      </Link>
    </div>
  );
}
